//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		name: "article-default",
		props: {
			article: Object,
            title: false,
            index: null,
        },
        mounted() {
            setTimeout(() => {
                $('.lazy').Lazy({
                    afterLoad: function(element) {
                        element.addClass('loaded');
                    },
                });
            }, 1000);
        }
	}
